/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
// import { getCodeLang } from './helpers/locale-helper';
Vue.use(Vuesax)

// Theme Configurations
import '../themeConfig.js'


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Globally Registered Components
import './globalComponents.js'



// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'

Vue.use(VueHammer)
VueHammer.config.swipe = {
  threshold: 200
};

// ACL
import acl from './acl/acl'

// i18n
import i18n from './i18n/i18n'

// Vuesax Admin Filters
import './filters/filters'

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// VeeValidate

import VeeValidate, { Validator } from 'vee-validate';
import pt_BR from "vee-validate/dist/locale/pt_BR";

Vue.use(VeeValidate, {
  events: ''
});


Validator.localize("pt_BR", pt_BR);

const dictionary = {
  pt_BR: {
    messages: {
      confirmed: () => `Os campos devem ser iguais`,
      email: () => 'E-mail inválido'
    }
  },
  en: {
    messages: {
      confirmed: () => "Fields must be the same",
      email: () => 'Invalid email'
    }
  },
  es: {
    messages: {
      confirmed: () => "Los campos deben ser los mismos",
      email: () => 'Email inválido'
    }
  },

};
Validator.localize(dictionary);
// Validator.localize("pt_BR", validateCustomMessage);

// Cryptojs
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs)

// Feather font icon
require('./assets/css/iconfont.css')

// Vue Tour css
import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

// Moment js
const moment = require('moment')
require('moment/locale/pt')

Vue.use(require('vue-moment'), {
  moment
})

// VuePlyr API
import VuePlyr from 'vue-plyr';
// The second argument is optional and sets the default config values for every player.
Vue.use(VuePlyr, {
  plyr: {
    i18n: {
      restart: 'Reiniciar',
      rewind: 'Voltar {seektime}s',
      play: 'Reproduzir',
      pause: 'Pausa',
      fastForward: 'Avançar {seektime}s',
      seek: 'Procurar',
      seekLabel: '{currentTime} of {duration}',
      played: 'Reproduzido',
      buffered: 'Buffered',
      currentTime: 'Tempo atual',
      duration: 'Duração',
      volume: 'Volume',
      mute: 'Mudo',
      unmute: 'Reativar som',
      enableCaptions: 'Ativar legenda',
      disableCaptions: 'Desativar legenda',
      download: 'Baixar',
      enterFullscreen: 'Tela cheia',
      exitFullscreen: 'Sair da tela cheia',
      frameTitle: 'Player for {title}',
      captions: 'Legendas',
      settings: 'Configurações',
      pip: 'PIP',
      menuBack: 'Voltar ao menu anterior',
      speed: 'Velocidade',
      normal: 'Normal',
      quality: 'Qualidade',
      loop: 'Loop',
      start: 'Início',
      end: 'Fim',
      all: 'Tudo',
      reset: 'Reiniciar',
      disabled: 'Desabilitado',
      enabled: 'Habilitado',
      advertisement: 'Ad',
      qualityBadge: {
        2160: '4K',
        1440: 'HD',
        1080: 'HD',
        720: 'HD',
        576: 'SD',
        480: 'SD',
      },
    },
    fullscreen: { enabled: true },
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
    settings: ['captions', 'quality', 'speed', 'loop'],
    quality: { default: 576, options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240] },
    youtube: { noCookie: false, rel: 0, showinfo: 1, iv_load_policy: 3, modestbranding: 1 }
  },
  emit: ['ended']
});

// Vue select css
// Note: In latest version you have to add it separately
import 'vue-select/dist/vue-select.css';
// import '@core/scss/vue/libs/vue-select.scss';

// import file communication received from wdma
require('./assets/lib/communication-receive');

// require('worker-loader!pdfjs-dist/build/pdf.worker');

// import {version} from "pdfjs-dist/build/pdf";
// console.log('-> ', version);
// import pdfjsLib from 'pdfjs-dist/build/pdf'
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
// pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.min.js";
// pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
// const pdfjsLib = import("pdfjs-dist");
// pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.js";


import '../bootstrap-client.js';

import 'vue-popperjs/dist/vue-popper.css';

import Cleave from 'vue-cleave-component';
Vue.use(Cleave);
import 'cleave.js/dist/addons/cleave-phone.br';

import VueGlide from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';
Vue.use(VueGlide);

import VueMask from 'v-mask';
Vue.use(VueMask);

import 'swiper/dist/css/swiper.min.css';

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
